export const formatNumber = (
  locale = 'id-ID',
  currency = 'IDR',
  value,
  minimumFractionDigits = 2
) => {
  return Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits,
  }).format(value);
};
